import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: "É gratuito mesmo?",
    answer: "Sim! A semana Java Dev Week é 100% gratuita. Não há nenhum tipo de cobrança para participar do evento."
  },
  {
    question: "Preciso ter experiência em Java?",
    answer: "Não. Começamos do absoluto zero. O evento foi desenhado para pessoas que nunca programaram em Java, mas também oferece conteúdo avançado para quem já tem alguma experiência."
  },
  // {
  //   question: "Vai ter certificado?",
  //   answer: "Sim, todos os participantes que assistirem às aulas receberão um certificado digital de participação, que pode ser adicionado ao seu LinkedIn."
  // },
  {
    question: "Como vou receber o acesso ao evento?",
    answer: "Após a inscrição, você receberá um e-mail com todas as instruções de acesso e o cronograma completo das aulas."
  },
  {
    question: "Por quanto tempo terei acesso ao conteúdo?",
    answer: "O acesso às gravações será disponibilizado até o encerramento do evento. Você poderá assistir e revisitar o conteúdo sempre que quiser."
  },
  {
    question: "Consigo acompanhar as aulas se trabalho durante o dia?",
    answer: "Sim! Todas as aulas ficarão gravadas e você poderá assistir no seu próprio ritmo. Além disso, teremos lives noturnas para quem trabalha durante o dia."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-8 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Perguntas Frequentes</h2>
          <p className="text-gray-600">
            Tire suas dúvidas sobre o evento e como participar.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`bg-white rounded-lg overflow-hidden shadow-sm border border-gray-100 transition-all duration-200 ${openIndex === index ? 'shadow-md' : ''}`}
            >
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none"
                onClick={() => toggleFaq(index)}
              >
                <h3 className="text-lg font-medium">{faq.question}</h3>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-[#f2055c]" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-400" />
                )}
              </button>
              
              <div 
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;